import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
export var ApiError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(ApiError, _Error);

  function ApiError() {
    return _Error.apply(this, arguments) || this;
  }

  return ApiError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var GenericError = /*#__PURE__*/function (_ApiError) {
  _inheritsLoose(GenericError, _ApiError);

  function GenericError(message) {
    var _this;

    _this = _ApiError.call(this, message) || this;
    _this.name = 'FetchError';
    return _this;
  }

  return GenericError;
}(ApiError);
export var HttpError = /*#__PURE__*/function (_ApiError2) {
  _inheritsLoose(HttpError, _ApiError2);

  function HttpError(code, message) {
    var _this2;

    _this2 = _ApiError2.call(this, message) || this;

    _defineProperty(_assertThisInitialized(_this2), "code", void 0);

    _this2.code = code;
    _this2.name = 'HttpError';
    return _this2;
  }

  return HttpError;
}(ApiError);
export var temporaryErrorHttpCodes = [408, // Request Timeout
429, // Too Many Requests
502, // Bad Gateway
503, // Service Unavailable
504, // Gateway Timeout
507, // Insufficient Storage
509, // Bandwidth Limit Exceeded
521, // Web Server Is Down
522, // Connection Timed Out
523, // Origin Is Unreachable
524 // A Timeout Occurred
];
//# sourceMappingURL=errors.js.map